import Vue from 'vue'
import Router from 'vue-router'
import home from '@/home'
import singup from '@/Singup'
import login from '@/Login'
import detail from '@/Detail'
import shopcar from '@/Shopcar'
import order from '@/order'
import shoplist from '@/shoplist'
import orderlist from '@/orderlist'
import pay from '@/pay'
import paysuccess from '@/Paysuccess'
import coming from '@/coming'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/home',
      name: 'home',
      component: home
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/singup',
      name: 'singup',
      component: singup
    },
    {
      path: '/detail',
      name: 'detail',
      component: detail
    },
    {
      path: '/shopcar',
      name: 'shopcar',
      component: shopcar
    },
    {
      path: '/order',
      name: 'order',
      component: order
    },
    {
      path: '/shoplist',
      name: 'shoplist',
      component: shoplist
    },
    {
      path: '/orderlist',
      name: 'orderlist',
      component: orderlist
    },
    {
      path: '/pay',
      name: 'pay',
      component: pay
    },
    {
      path: '/paysuccess',
      name: 'paysuccess',
      component: paysuccess
    },
    {
      path: '/',
      name: 'coming',
      component: coming
    }
  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js